import Reveal from "./Reveal";
import { IMG } from "../data/content";
import { ArrowRight } from "lucide-react";

export default function Founder({ onStartQuiz }) {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-12 lg:py-16">
      <div className="max-w-5xl mx-auto px-5">
        <Reveal>
          <div className="glass-card rounded-[28px] p-8 sm:p-12 relative overflow-hidden">
            <div
              className="absolute -top-24 -right-24 h-72 w-72 rounded-full opacity-20 blur-3xl"
              style={{ background: "radial-gradient(closest-side, #00C6EF, transparent)" }}
              aria-hidden="true"
            />
            <div className="relative grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 items-center">
              <div className="mx-auto md:mx-0">
                <div className="relative">
                  <div className="absolute -inset-1.5 rounded-full bg-gradient-to-tr from-sky-400 to-blue-600 opacity-80 blur-md" aria-hidden="true" />
                  <img
                    src={IMG.founder}
                    alt="Brandon Beal, Founder and CEO of Breeze"
                    loading="lazy"
                    className="relative h-32 w-32 sm:h-40 sm:w-40 rounded-full object-cover border-2 border-white/20"
                  />
                </div>
                <div className="mt-4 text-center md:text-left">
                  <div className="text-lg font-extrabold text-white">Brandon Beal</div>
                  <div className="text-xs font-semibold tracking-[0.2em] uppercase text-sky-300">Founder/CEO</div>
                </div>
              </div>
              <blockquote className="text-sm sm:text-base leading-relaxed text-slate-300">
                “What separates us from everyone else in the space? We have the ‘receipts’. While others talk it, we show
                it. We show you exactly how to build real financial freedom—and have the receipts to prove it’s possible.
                This isn’t reserved for the lucky; anyone willing to put in the{" "}
                <strong className="text-white">GRIT</strong> and <strong className="text-white">GRIND</strong> can do it.
                Because that’s what gets you to the <strong className="breeze-text">GLITTER</strong> and{" "}
                <strong className="breeze-text">GOLD</strong>. We’re here to help you make it happen.”
              </blockquote>
            </div>
            <div className="relative mt-9 flex justify-center">
              <button
                onClick={onStartQuiz}
                data-testid="founder-cta-join-team"
                className="btn-primary-glow rounded-full px-9 py-4 text-base font-bold text-white inline-flex items-center gap-2"
              >
                Join the Team
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
